import React, { useState, useEffect } from 'react';
import {
  Box,
  IconButton,
  Typography,
  Menu,
  MenuItem,
  AppBar,
  Toolbar,
  Avatar,
  useMediaQuery,
} from '@mui/material';
import { Menu as MenuIcon, ExitToApp } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const TopNav = ({ toggleSidebar }) => {
  const isMobile = useMediaQuery('(max-width:768px)');
  const navigate = useNavigate();

  const [anchorEl, setAnchorEl] = useState(null);
  const isMenuOpen = Boolean(anchorEl);
  const [hospitalData, setHospitalData] = useState(null);
  const [firstName, setFirstName] = useState('');
  const [staffCount, setStaffCount] = useState(null);

  useEffect(() => {
    const dummyHospital = {
      hospital_name: 'Human Resource Management',
     
    };
    setHospitalData(dummyHospital);
  }, []);

  useEffect(() => {
    const fetchUserName = async () => {
      const email = localStorage.getItem('email');
      if (!email) return;

      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_BASE_URL}/get_adminuser_names.php`,
          { email },
          { headers: { 'Content-Type': 'application/json' } }
        );

        if (response.data.success && response.data.data) {
          setFirstName(response.data.data.first_name);
        } else {
          console.error('User fetch failed:', response.data.message);
        }
      } catch (err) {
        console.error('API error:', err);
      }
    };

    fetchUserName();
  }, []);

  useEffect(() => {
    const fetchStaffCount = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/staff_count.php`
        );
        if (response.data.success) {
          setStaffCount(response.data.count);
        } else {
          console.error('Failed to fetch staff count:', response.data.message);
        }
      } catch (err) {
        console.error('API error (staff count):', err);
      }
    };

    fetchStaffCount();
  }, []);

  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleNavigate = (path) => {
    handleMenuClose();
    navigate(path);
  };

  const handleLogout = () => {
    localStorage.removeItem('email');
    sessionStorage.clear();
    navigate('/');
  };


  const getGreeting = () => {
  const hour = new Date().getHours();
  if (hour < 12) return 'Good Morning';
  if (hour < 18) return 'Good Afternoon';
  return 'Good Evening';
};

// ...

<Typography variant="h6" sx={{ color: 'white' }}>
  {getGreeting()}, {firstName || 'User'}
</Typography>

  return (
    <AppBar
      position="sticky"
      elevation={3}
      sx={{
        top: 0,
        backgroundColor: '#C84646', // Oxblood red
      }}
    >
      <Toolbar sx={{ justifyContent: 'space-between', minHeight: '48px' }}>
        {isMobile && (
          <IconButton color="inherit" onClick={toggleSidebar}>
            <MenuIcon />
          </IconButton>
        )}

        <Box sx={{ display: 'flex', alignItems: 'center', width: '100%', justifyContent: 'space-between' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 15 }}>
            <Typography variant="h6" sx={{ color: 'white' }}>
              {hospitalData?.hospital_name}
            </Typography>
            {staffCount !== null && (
              <Typography variant="h6" sx={{ color: 'white' }}>
                Total Onboard Staff: {staffCount}
              </Typography>
            )}
          </Box>

         <Typography variant="h6" sx={{ color: 'white' }}>
  {getGreeting()}, {firstName || 'User'}
</Typography>
        </Box>

        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <IconButton color="inherit" onClick={handleProfileMenuOpen}>
            <Avatar sx={{ bgcolor: 'secondary.main' }}>
              {firstName ? firstName.charAt(0).toUpperCase() : 'U'}
            </Avatar>
          </IconButton>

          <Menu
            anchorEl={anchorEl}
            open={isMenuOpen}
            onClose={handleMenuClose}
            MenuListProps={{ 'aria-labelledby': 'profile-button' }}
          >
           
            <MenuItem onClick={() => handleNavigate('#')}>Change Password</MenuItem>
          </Menu>

          <IconButton color="inherit" onClick={handleLogout}>
            <ExitToApp />
          </IconButton>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default TopNav;
